/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState } from 'react'

export interface ParamObject {
  id?: number
  name: string
  paramClass: string
  family: string
  type: {id:number, typeName:string}
  structuresArray: StructureObject[]
  astm: string
  uns: string
  din: string
  aisi: string
  others: string
}

export interface MainFieldsParamObject {
  id?: number
  name: string
  paramClass: string
  family: string
  type: {id:number, typeName:string}
  astm: string
  uns: string
  din: string
  aisi: string
  others: string
}

export interface StructureObject {
  id?: number
  name: string
  fileImport: boolean
  hasTable: boolean
  hasMinMax: boolean
  minTable: string[][]
  maxTable: string[][]
  tableRows: string[]
  tableColumns: string[]
  format: string
}

const startingMainFieldsParameters: MainFieldsParamObject = {
  name: '',
  paramClass: '',
  family: '',
  type: {id: 0, typeName: ''},
  astm: '',
  uns: '',
  din: '',
  aisi: '',
  others: '',
}

interface ParametersContextProps {
  parametersTableQuantity: number
  setParametersTableQuantity: React.Dispatch<React.SetStateAction<number>>
  parameters: ParamObject[]
  setParameters: React.Dispatch<React.SetStateAction<ParamObject[]>>
  mainFields: MainFieldsParamObject
  setMainFields: React.Dispatch<React.SetStateAction<MainFieldsParamObject>>
  structures: StructureObject[]
  setStructures: React.Dispatch<React.SetStateAction<StructureObject[]>>
  editStructureIndex: number
  setEditStructureIndex: React.Dispatch<React.SetStateAction<number>>
  editParameterIndex: number
  setEditParameterIndex: React.Dispatch<React.SetStateAction<number>>
}

export const startingStructuresParameters: StructureObject[] = [
  {
    name:'Composição química',
    tableColumns:['C'],
    tableRows:[''],
    fileImport:false,
    hasMinMax:false,
    format:'Selecione',
    hasTable:true,
    maxTable:[],
    minTable:[]
  },
  {
    name:'Ensaios mecânicos',
    tableColumns:['Tração'],
    tableRows:[''],
    fileImport:false,
    hasMinMax:false,
    format:'',
    hasTable:true,
    maxTable:[],
    minTable:[]
  },
]

const ParametersContext = createContext<ParametersContextProps>({
  parametersTableQuantity: 7,
  setParametersTableQuantity: () => {},
  parameters: [],
  setParameters: () => {},
  mainFields: startingMainFieldsParameters,
  setMainFields: () => {},
  structures: [],
  setStructures: () => {},
  editStructureIndex: -1,
  setEditStructureIndex: () => {},
  editParameterIndex: -1,
  setEditParameterIndex: () => {}
})

export default ParametersContext

export const ParametersProvider: React.FC<any> = ({ children }) => {
  const [ parametersTableQuantity, setParametersTableQuantity ] = useState<number>(7)
  const [ parameters, setParameters ] = useState<ParamObject[]>([])
  const [ mainFields, setMainFields ] = useState<MainFieldsParamObject>(startingMainFieldsParameters)
  const [ structures, setStructures ] = useState<StructureObject[]>(startingStructuresParameters)
  const [ editStructureIndex, setEditStructureIndex ] = useState<number>(-1)
  const [ editParameterIndex, setEditParameterIndex ] = useState<number>(-1)

  return (
    <ParametersContext.Provider
      value={{
        parametersTableQuantity,
        setParametersTableQuantity,
        parameters,
        setParameters,
        mainFields,
        setMainFields,
        structures,
        setStructures,
        editStructureIndex,
        setEditStructureIndex,
        editParameterIndex,
        setEditParameterIndex,
      }}
    >
      {children}
    </ParametersContext.Provider>
  )
}
